module.exports = __webpack_public_path__ + "img/7rooms.5f3cbedd.jpeg";